export enum DesignBranchingEventType {
  initBranch = 'init',
  initBranchingMap = 'init-branchingMap',
  merge = 'merge',
  pull = 'pull'
}

export type BaseDesignBranchingEvent = {
  author: string;
  timestamp: number;
  type: DesignBranchingEventType;
};

export type DesignBranchingEventInitBranching = {
  branch_id: string;
  branch_name: string;
  branched_at: string;
  type: DesignBranchingEventType.initBranchingMap;
} & BaseDesignBranchingEvent;

export type DesignBranchingEventMerge = {
  branch_id: string;
  branch_name: string;
  merged_at: string;
  type: DesignBranchingEventType.merge;
} & BaseDesignBranchingEvent;

/**
 * Events that can happen on the main design.
 *
 * @note These events should be stored on @see Design.branchingMap.
 */
export type DesignMainBranchingEvent = (
  DesignBranchingEventInitBranching
  | DesignBranchingEventMerge
);

export type DesignBranchingEventInit = {
  branched_at: string;
  parent_branch_id: string;
  parent_branch_name: string;
  type: DesignBranchingEventType.initBranch;
} & BaseDesignBranchingEvent;

export type DesignBranchingEventPull = {
  parent_application: string;
  pulled_at: string;
  type: DesignBranchingEventType.pull;
} & BaseDesignBranchingEvent;

/**
 * Events that can happen on branched designs.
 *
 * @note These events should be stored on @see Design.branching.
 */
export type DesignBranchBranchingEvent = (
  DesignBranchingEventInit
  | DesignBranchingEventPull
);

export type DesignBranchingEvent = (
  DesignBranchBranchingEvent
  | DesignMainBranchingEvent
);
